import { FunctionComponent } from 'react';

import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';
import { CircularProgress } from '@mui/material';
import BreakoutRoomOptionsContainer from '../BreakoutRoomOptionsContainer';
import { StyledPanelContainer } from '../styles/styled-components';
import BreakoutRoomRowItem from './BreakoutRoomRowItem';

const BreakoutRoomRowCollection: FunctionComponent = () => {
    const { ready } = useTranslation();
    const { roomState } = useContainer(BreakoutRoomOptionsContainer);

    const buildRows = () => roomState?.map((room) => <BreakoutRoomRowItem key={room.id} roomId={room.id} roomName={room.name} roomUsers={room.users} />);

    if (ready) {
        return <StyledPanelContainer>{buildRows()}</StyledPanelContainer>;
    }

    return <CircularProgress />;
};

export default BreakoutRoomRowCollection;
